export default __webpack_public_path__ + "static/media/IpHomeOff.b7a2f610.svg";